import { useState } from 'react';

import { message } from 'antd';
import axios from 'axios';
import { isArray } from 'lodash';

import { SettingsManager } from '@classes/settingsManager';
import { GlobalConstants } from '@constants/global';
import { useQuery } from '@tanstack/react-query';

import { Conflict, TScheduleException } from '../common/types';

interface IProps {
    curException: TScheduleException;
    crmIds?: number[];
}

export const useCheckEventOverlap = ({
    curException,
    crmIds,
}: IProps): {
    conflicts: Array<Conflict>;
} => {
    const [conflicts, setConflicts] = useState<Array<Conflict>>([]);
    const { duration, start_date, start_time } = curException || {};

    const checkEventOverlap = async () => {
        try {
            const creds = SettingsManager.getConnectionCredentials();

            await axios.post(
                `${GlobalConstants.BaseUrl}/schedule-exceptions/check-event-overlap`,
                {
                    // ToDo: Добавить проверку нескольких ЦРМ
                    crm_id: isArray(crmIds) ? crmIds : [creds.crmID],
                    duration,
                    start_date,
                    start_time,
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + creds.token,
                    },
                }
            );
            setConflicts([]);
        } catch (err) {
            err?.response?.data?.errors?.start_time?.message &&
                message.error(err?.response?.data?.errors?.start_time?.message);

            err?.response?.data?.errors?.start_time?.conflicts &&
                setConflicts(err?.response?.data?.errors?.start_time?.conflicts);
        }
    };

    useQuery({
        queryKey: [duration, start_date, start_time],
        queryFn: checkEventOverlap,
        enabled: !!duration && !!start_date && !!start_time,
    });

    return { conflicts };
};
